/**
 * Checks whether the specified variable is a function.
 *
 * @param variable
 * @returns {boolean}
 */
export const isFunction = (variable) => {
    return typeof variable === 'function'
}

export function debounce(func, wait = 300){
    let timeout
    return function(...args) {
        const context = this
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(context, args), wait)
    }
}